// tslint:disable: variable-name
import { BaseResourceModel } from '../../models/base-resource.model';
import { Liquidacao } from './liquidacao.model';

export class LiquidacaoDeducaoReinf extends BaseResourceModel {
    constructor(
        public id?: number,
        public tipo?: number,
        public valor_deducao?: number,
        public previdencia_complementar?: boolean,
        public cnpj_previdencia_complementar?: string,
        public valor_patrocinador?: number,
        public liquidacao?: Liquidacao
    ) {
        super();
    }

    static converteJson(json: any): LiquidacaoDeducaoReinf {
        return Object.assign(new LiquidacaoDeducaoReinf(), json);
    }
}
